<script lang="ts" module>
	export type { HintProps, HintSize } from './Hint.types';
</script>

<script lang="ts">
	import { hintVariants } from './Hint.logic';
	import type { HintProps } from './Hint.types';

	let { size = 'xs', class: className, children }: HintProps = $props();
</script>

<span class={hintVariants({ size, class: className })}>
	{@render children?.()}
</span>
